 
/**
 * Creates an array from the range extremes provided:
 *
 * @param {Number} start - Start index provided from where the return Array starts (included).
 * @param {Number} stop - End index provided to where the return Array ends (included).
 * @param {Number} step - (Optional). Steps between position in the array. Default = 1.
 *
 * @returns {Array} Array of length (stop - start) with the calculated elements from ranges.
 */

export default function range(start, stop, step = 1) {
  if (isNaN(start) || isNaN(stop)) return [];
  return Array.from(
    { length: (stop - start) / step + 1 }, //{length: num} is an arrayLike iterable object
    (_, index) => start + index * step
  );
}
